module.exports = __webpack_public_path__ + "static/001_001-c2038d082cddbd59dc791b30d2f0a351.jpg";